import { Sparkles } from "lucide-react";
import { SignOutButton } from "@/components/sign-out-button";

export function AppHeader() {
  return (
    <header className="flex items-center justify-between border-border border-b bg-card px-4 py-3 md:px-6">
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/20">
          <Sparkles className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="font-bold text-foreground text-lg tracking-wide">
            AI Game Master
          </h1>
          <p className="hidden text-muted-foreground text-xs sm:block">
            AI Game Master
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <span className="rounded-full bg-primary/20 px-2 py-1 text-primary text-xs">
          Session Active
        </span>
        <SignOutButton />
      </div>
    </header>
  );
}
